module.exports = __webpack_public_path__ + "static/bannerImage-23054fc22c9bbef46292d77ddb12f28d.jpg";